import { Switch as S } from '@headlessui/react';
import cn from 'classnames';
import PopOverQuestionMark from '../popover-question-mark';

type SwitchProps = {
   open: boolean;
   onChange: (type: boolean) => any;
   label?: React.ReactNode;
   id: string;
   description?: React.ReactNode;
   disabled?: boolean;
   helperText?: React.ReactNode;
};
export const Switch = ({
   label,
   description,
   onChange,
   open,
   id,
   disabled,
   helperText,
}: SwitchProps) => {
   return (
      <div className="flex items-start justify-between">
         <div>
            <label htmlFor={id} className="flex gap-3 items-center font-semibold sm:text-lg">
               {label} {helperText ? <PopOverQuestionMark content={helperText} /> : null}
            </label>
            {description && <p className="text-xs text-grey-300">{description}</p>}
         </div>
         <S
            id={id}
            checked={open}
            onChange={onChange}
            disabled={disabled}
            className={cn(
               'h-[22px] w-[40px] rounded-full flex items-center',
               open ? 'bg-[#51C041]' : 'bg-gray-300',
               disabled && '!bg-gray-300 cursor-not-allowed'
            )}>
            <span
               className={cn(
                  open
                     ? 'rtl:-translate-x-5 ltr:translate-x-5'
                     : 'rtl:-translate-x-1 ltr:translate-x-1',
                  'inline-block w-4 h-4 transform transition-all bg-white rounded-full'
               )}
            />
         </S>
      </div>
   );
};
